import React, { useState } from 'react'
import Card from '../nura/card/card'
import Modal from '../modal/modal'

import BaseForm from "../base-form/base-form"
import Button from '../nura/button/button'
import { createDeveloperAPIKeys } from '../../api-client/data'
import { StandardInput } from './run-blueprint'
import styles from './styles.module.css'
import useFlow from '../../hooks/useFlow'

import withDialog from './withDialog'

export default withDialog(({ show, setShow, onClose }) => {
    const [isLoading, setIsLoading] = useState(false)
    
    const flow = useFlow({
        onBack: () => setShow(false),
        onSubmit: () => setShow(true),
    })

    const onCreateAPIKey = async () => {
        setIsLoading(true)
        const { value } = await createDeveloperAPIKeys(flow.formValues['name'])
        setIsLoading(false)

        flow.onClickChange('apiKey')(value)
    }

    return (
        <Modal show={show} onClose={() => setShow(false)}>
            <Card variant="modal" style={{ width: 358 }}>
                <BaseForm onBack={() => setShow(false)} title={flow.step == 0 ? "Create API Key" : "Save your key"}>
                    {
                        ({
                            [0]: (
                                <>
                                    <div style={{ marginBottom: 15 }}>
                                        <StandardInput name="Name">
                                            <div className={styles.textAreaContainer}>
                                                <input
                                                    className={styles.textArea}
                                                    onChange={({ target: { value } }) => flow.onChange('name')(value)}
                                                />
                                            </div>
                                        </StandardInput>
                                    </div>
                                    <Button variant="primary" loading={isLoading} onClick={onCreateAPIKey}>Create</Button>
                                </>
                            ),
                            [1]: (
                                <>
                                    <div style={{ marginTop: 25 }}>
                                        Please save your key in a save place, you will not be able to view it after
                                        you leave this dialog.
                                    </div>
                                    <div style={{ marginBottom: 15 }}>
                                        <StandardInput name="API Key">
                                            <div className={styles.textAreaContainer}>
                                                <input
                                                    className={styles.textArea}
                                                    readOnly
                                                    value={flow.formValues['apiKey']}
                                                />
                                            </div>
                                        </StandardInput>
                                    </div>
                                    
                                    <Button loading={isLoading} variant="primary" onClick={onClose}>Done</Button>                                    
                                </>
                            )
                        })[flow.step]
                    }

                </BaseForm>
            </Card>
        </Modal>
    )
})